import styled from 'styled-components';

const css = {};

css.MainTableWrapper = styled.div`
  padding: 0 10px;
`;

css.WeeksTable = styled.div`
  display: table;
  position: relative;
  width: 100%;
  border-collapse: separate;
  border-spacing: 5px;
  font-weight: 400;
`;

css.Tr = styled.div`
  display: table-row;
`;

export default css;
